(() => {
  'use strict';
  if (window.gsRituelGuideReady) return;
  window.gsRituelGuideReady = true;
  const states = new WeakMap();
  function fillPrices(dialog, root) {
    const target = dialog.querySelector('[data-rituel-price]');
    target.replaceChildren();
    let data;
    try { data = JSON.parse(root.querySelector('[data-sub-data]').textContent); } catch (_) { return; }
    const variant = data[root.querySelector('[data-variant-id]')?.value];
    const planId = root.querySelector('[data-po-freq]')?.value;
    const plan = variant?.plans?.find(p => String(p.id) === planId) || variant?.plans?.[0];
    const fr = (dialog.dataset.locale || document.documentElement.lang).startsWith('fr');
    if (!plan) { target.textContent = fr ? 'Consultez les formules disponibles sur la fiche produit.' : 'See the available plans on the product page.'; return; }
    const currency = window.Shopify?.currency?.active || 'EUR';
    const money = value => new Intl.NumberFormat(dialog.dataset.locale || document.documentElement.lang || 'fr', {style:'currency',currency}).format(value / 100);
    const line = text => { const p = document.createElement('p'); p.textContent = text; target.append(p); };
    const known = Number.isFinite(plan.renewalPrice) && Number.isInteger(plan.renewalAfterOrders) && plan.renewalAfterOrders >= 0;
    const sameHeadPrice = dialog.dataset.productKind === 'heads' && known && plan.price === plan.renewalPrice;
    const cadence = plan.cadenceLabel || plan.name;
    if (sameHeadPrice) {
      const inlineCadence = plan.cadenceLabel ? cadence.charAt(0).toLocaleLowerCase() + cadence.slice(1) : cadence;
      line((fr ? 'Avec le Rituel : ' : 'With the Ritual: ') + money(plan.price) + (fr ? ' par tête, dès la première commande puis ' : ' per head, from the first order and then ') + inlineCadence + '.');
    } else {
      line((fr ? 'Avec le Rituel : ' : 'With the Ritual: ') + money(plan.price) + (dialog.dataset.productKind === 'razor' ? (fr ? ' pour le rasoir.' : ' for the shaver.') : (fr ? ' pour la tête choisie.' : ' for the selected head.')));
      if (known) {
        const timing = plan.renewalAfterOrders > 1 ? (fr ? `Après ${plan.renewalAfterOrders} commandes : ` : `After ${plan.renewalAfterOrders} orders: `) : (fr ? 'Recharges suivantes : ' : 'Subsequent refills: ');
        line(timing + money(plan.renewalPrice) + (fr ? ' par recharge · ' : ' per refill · ') + cadence + '.');
      } else line(fr ? 'Consultez les montants de renouvellement dans les modalités de la formule.' : 'See the plan terms for renewal amounts.');
    }
    line(fr ? 'Livraison offerte avec le Rituel, sans minimum d’achat.' : 'Free delivery with the Ritual, with no minimum spend.');
  }
  document.addEventListener('click', event => {
    const opener = event.target.closest('[data-rituel-open]');
    if (opener) {
      if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
      const dialog = document.getElementById(opener.getAttribute('aria-controls'));
      const root = opener.closest('[data-product-root]');
      if (!dialog || !root || typeof dialog.showModal !== 'function') return;
      event.preventDefault();
      if (dialog.open) return;
      fillPrices(dialog, root);
      states.set(dialog, {opener,overflow:document.body.style.overflow});
      document.body.append(dialog);
      dialog.showModal();
      document.body.style.overflow = 'hidden';
      if (!dialog.dataset.bound) {
        dialog.dataset.bound = 'true';
        dialog.addEventListener('close', () => {
          const state = states.get(dialog);
          document.body.style.overflow = state?.overflow || '';
          if (state?.opener?.isConnected) state.opener.focus({preventScroll:true});
        });
        dialog.addEventListener('click', e => {
          if (e.target !== dialog) return;
          const rect = dialog.getBoundingClientRect();
          if (e.clientX < rect.left || e.clientX > rect.right || e.clientY < rect.top || e.clientY > rect.bottom) dialog.close();
        });
      }
      return;
    }
    const close = event.target.closest('[data-rituel-close]');
    if (close) close.closest('dialog')?.close();
  });
})();
